import { render, staticRenderFns } from "./StepBasedForm.vue?vue&type=template&id=5d4ff425&scoped=true&"
import script from "./StepBasedForm.vue?vue&type=script&lang=js&"
export * from "./StepBasedForm.vue?vue&type=script&lang=js&"
import style0 from "./StepBasedForm.vue?vue&type=style&index=0&id=5d4ff425&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d4ff425",
  null
  
)

export default component.exports